module.exports = __webpack_public_path__ + "static/assets/0418b3b4a528031d00e0d1d576f672f2.svg";